import EventBus from "@/utils/event-bus";
import JSZip from "jszip";
import alertMixins from "@/mixins/alertMixins";

export default {
    created() {
    },
    mounted() {

    },
    mixins: [alertMixins],
    data() {
        return {
            imageMaxSize: 20 * 1024 * 1024,
            zipFiles: [],
            imgArr: [],
            files: [],
        }
    },
    computed: {},
    methods: {
        zipFileUpload(file, fileList) {
            let type = file.raw.type.split('/');
            let _this = this
            file.name = this.regExp(file.name)
            if (!(type[1] === 'x-zip-compressed')) {
                this.errorAlert('ZIP 파일만 업로드 가능합니다.')
                fileList.pop();
            } else {
                EventBus.$emit('apiLoading', true);
                this.zipFiles = [];
                this.zipFiles.push(file);
                if (this.parentChange) {
                    this.parentChange('zipFiles', this.zipFiles);
                }
                let JSZip = require("jszip");
                let new_zip = new JSZip();
                new_zip.loadAsync(file.raw).then(function (zip) {
                    _this.runUnzipFiles(zip)
                });
                this.$forceUpdate();
            }
        },
        regExp(str) {
            let reg = /[\{\}\[\]\/?,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\" ]/gi
            if (reg.test(str)) {
                return str.replace(reg, "_");
            } else {
                return str
            }
        },
        runUnzipFiles(zip) {
            this.unZipFiles(zip, 0);
        },
        unZipFiles(zip, index = 0) {
            let _this = this
            this.imgArr = [];
            this.files = [];
            zip.forEach(function (relativePath, entry) {
                let ext = '';
                if (entry.name.length < 4) {
                    return;
                }
                ext = entry.name.split(".").pop()
                if (ext === 'jpg' || ext === 'png') {
                    _this.imgArr.push(entry)
                }
            });
            this.runConvertUrl(zip);
        },
        runConvertUrl(zip, index = 0) {
            let _this = this
            if (index > this.imgArr.length - 1) {
                EventBus.$emit('apiLoading', false)
                if (this.parentChange) {
                    this.parentChange('files', this.files);
                }
                return true
            }
            let entry = this.imgArr[index]
            zip.file(entry.name).async("base64").then(function (base64Text) {
                let data = 'data:image/jpeg;base64, ' + base64Text
                let name = _this.regExp(entry.name)
                _this.convertURLtoFile(data, name).then(res => {
                    _this.runConvertUrl(zip, index + 1);
                })
            });
        },
        convertURLtoFile(url, name) {
            let file = {}
            let data = {}
            let ext = ''
            let fileUrl = ''
            let metadata = ''
            return fetch(url).then((res) => res.blob())
                    .then((response) => {
                        fileUrl = window.URL.createObjectURL(response);
                        ext = url.split(":").pop();
                        ext = ext.split(";").shift();
                        metadata = {type: `${ext}`};
                        data = new File([response], name, metadata);
                        file = {
                            webSrc: fileUrl,
                            org_url: fileUrl,
                            fileSrc: url,
                            raw: data,
                            wr_is_event: true,
                            org_name: name,
                            name: name,
                            size: data.size,
                            type: metadata.type,
                        }
                        if (this.imageMaxSize > file.size) {
                            this.files.push(file);
                        }
                        return true;
                    })
        },
        removeZip() {
            this.zipFiles = []
            this.imgArr = []
            this.zipFiles = []
        },
    }
}